import { type TopUpRequest } from '@carsfinders/contracts';
import { Link } from '@tanstack/react-router';

import { t } from '../../../../lib/i18n';
import { FINANCE_DEPOSITS_SEARCH } from '../../../finance/components/finance-view-switch';
import { formatChf, formatDate } from './finance-format';

/**
 * The client announced a top-up that nobody has confirmed yet. Shown so the
 * operator confirms THAT request (in «Фінанси → Депозити й режими») rather than
 * recording the same money a second time through «Додати платіж».
 */
export function OpenTopUpBanner({ requests }: { requests: TopUpRequest[] }) {
  if (requests.length === 0) return null;
  return (
    <section
      role="status"
      data-testid="finance-open-topup"
      className="flex flex-col gap-1.5 rounded-cf-lg border border-cf-line bg-cf-warn-tint px-4 py-3 text-[13px] leading-[1.5] text-cf-ink lg:px-6"
    >
      <strong className="font-semibold">{t('clients.finance.banner.title')}</strong>
      <ul className="m-0 flex list-none flex-col gap-0.5 p-0 font-mono text-[13px]">
        {requests.map((request) => (
          <li key={request.id}>
            {t('clients.finance.banner.request', {
              amount: formatChf(request.amountChf),
              date: formatDate(request.createdAt),
            })}{' '}
            · {request.reference}
          </li>
        ))}
      </ul>
      <Link
        to="/finance"
        search={FINANCE_DEPOSITS_SEARCH}
        className="w-fit font-semibold text-cf-ink underline underline-offset-2 hover:text-cf-brand focus-visible:outline-2 focus-visible:outline-cf-ink"
      >
        {t('clients.finance.banner.link')}
      </Link>
    </section>
  );
}
